import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const commonState = (state: RootState) => state.common;

export const getUser = createSelector(commonState, (common) => common.user);
export const getIsAuthenticated = createSelector(commonState, (common) => common.isAuthenticated);
export const getFormIsOpen = createSelector(commonState, (common) => common.formIsOpen);
export const getPageTitle = createSelector(commonState, (common) => common.pageTitle);
export const getVersion = createSelector(commonState, (common) => common.version);
export const getTenant = createSelector(commonState, (common) => common.tenant);
export const getTenantSettings = createSelector(commonState, (common) => common.tenantSettings);
export const getTenantTheme = createSelector(commonState, (common) => common.tenantTheme);
export const getTimesheetNotifications = createSelector(commonState, (common) => common.timesheetNotifications);

export const getUserIsAdmin = createSelector(
    getUser,
    (user) => user?.roles.some(x => x.name === 'Administrator'),
);